import { i18n } from 'i18n';

import { TRANSFORM_LOCALE } from './transformLocale';

export const formatDate = (
	date: Date | null,
	format: 'short' | 'medium' | 'long' | 'json' | 'iso' | 'month' | 'year' | 'day' | 'chart' | 'time' | 'full' = 'short',
	filter: 'from' | 'to' = 'from',
) => {
	if (!date) {
		return null;
	}

	switch (format) {
		case 'short':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
			});

		case 'medium':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

		case 'full':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
			});

		case 'time':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
			});

		case 'long':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'short',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
			});

		case 'json':
			date.setTime(date.getTime() - date.getTimezoneOffset() * 60000);

			if (filter === 'to') {
				date.setDate(date.getDate() + 1);
				date.setMilliseconds(date.getMilliseconds() - 1);
			}

			return date.toJSON().replace('Z', '');

		case 'iso':
			return date.toLocaleDateString('sv-SE');

		case 'month':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'long',
				year: 'numeric',
			});

		case 'year':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				year: 'numeric',
			});

		case 'day':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				weekday: 'short',
			});

		case 'chart':
			return date.toLocaleString(TRANSFORM_LOCALE[i18n.language], {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			});

		default:
			return null;
	}
};
